import { render, staticRenderFns } from "./CategoryCardSlider.vue?vue&type=template&id=356d50b9&"
import script from "./CategoryCardSlider.vue?vue&type=script&lang=js&"
export * from "./CategoryCardSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports